<template>
  <div class="layout-base--private">
    <v-app-bar app flat clipped-left dark color="primary">
      <v-app-bar-nav-icon @click="() => toggleNavDrawer()" />

      <app-bar-home-link />

      <v-spacer />

      <user-menu />
    </v-app-bar>

    <v-hover>
      <template v-slot:default="{ hover }">
        <v-navigation-drawer
          app
          clipped

          :value="shouldShowNavigation"
          @input="(newVal) => setNavDrawerState(newVal)"

          :mini-variant="shouldUseMiniVariant && !hover"
        >
          <nav-tree-root nav dense :items="navItems" />
        </v-navigation-drawer>
      </template>
    </v-hover>

    <v-main>
      <v-container fluid style="min-height: 100%;">
        <v-fade-transition mode="in-out">
          <v-breadcrumbs
            class="px-2 mb-4"
            :items="breadcrumbItems"
            v-if="shouldShowBreadcrumbs"
            style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
          />
        </v-fade-transition>

        <v-progress-linear
          top
          absolute
          indeterminate
          color="accent"
          :active="isPageLoading"
        />

        <v-slide-x-transition mode="out-in">
          <slot />
        </v-slide-x-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import vuetify from '@/plugins/vuetify';
import storage from '@/services/storage';
import store from '@/services/store';
import { signOut } from '@/services/auth';

import NavTreeRoot from '@/components/NavTree/NavTreeRoot.vue';

import AppBarHomeLink from './components/AppBarHomeLink.vue';
import UserMenu from './components/UserMenu.vue';

import { storageKeys } from './config';

export default {
  name: 'LayoutBasePrivate',

  components: {
    NavTreeRoot,
    AppBarHomeLink,
    UserMenu,
  },

  data: () => ({
    isNavigationOpen: false,
    isMiniVariant: storage.getItem(storageKeys.MINI_VARIANT) !== 'off',
  }),

  computed: {
    shouldShowNavigation: (vm) => vuetify.framework.breakpoint.lgAndUp || vm.isNavigationOpen,
    shouldUseMiniVariant: (vm) => vuetify.framework.breakpoint.lgAndUp && vm.isMiniVariant,

    // TODO: Check user access level (A simple filter should work)
    navItems: () => store.state.auth?.currentUser?.navigation ?? [],

    isPageLoading: () => store.getters['layout/isLoading'],

    breadcrumbItems: (vm) => vm.$route.matched.reduce((items, route) => (
      route.meta.breadcrumbs ? [...items, ...route.meta.breadcrumbs] : items
    ), []),

    shouldShowBreadcrumbs: (vm) => vm.breadcrumbItems.length > 0,
  },

  watch: {
    isMiniVariant(newState) {
      storage.setItem(storageKeys.MINI_VARIANT, newState ? 'on' : 'off');
    },
  },

  methods: {
    signOut: (...args) => signOut(...args),

    setNavDrawerState(value) {
      this.isNavigationOpen = value;
    },

    toggleNavDrawer() {
      if (vuetify.framework.breakpoint.lgAndUp) {
        this.isMiniVariant = !this.isMiniVariant;
        return;
      }

      this.isNavigationOpen = !this.isNavigationOpen;
    },
  },
};
</script>
